type Business = {
  [operation: string]: {
    [model: string]: API.Permission;
  };
};

export const BUSINESS = {
  WRITE: {
    DUAL_APPROVAL_REQUEST: {
      model_str: "indigo.DualApprovalRequest",
      operation: "write",
      uuid: "*",
    },
    TRANSACTION: {
      model_str: "indigo.Transaction",
      operation: "write",
      uuid: "*",
    },
    INTRA_INSTITUTION_TRANSFER: {
      model_str: "indigo.IntraInstitutionTransfer",
      operation: "write",
      uuid: "*",
    },
    ORGANIZATION: {
      model_str: "indigo.Organization",
      operation: "write",
      uuid: "*",
    },
    DOMESTIC_WIRE_TRANSACTION: {
      model_str: "indigo.WireTransaction",
      operation: "write",
      uuid: "*",
    },
    WIRE_TEMPLATES: {
      model_str: "indigo.FedwireTemplate",
      operation: "write",
      uuid: "*",
    },
    RECIPIENT: {
      model_str: "indigo.Recipient",
      operation: "write",
      uuid: "*",
    },
    FEDWIRE_TEMPLATE: {
      model_str: "indigo.FedwireTemplate",
      operation: "write",
      uuid: "*",
    },
    FEDWIRE_VIA_TEMPLATE: {
      model_str: "indigo.FedwireViaTemplate",
      operation: "write",
      uuid: "*",
    },
    SWIFT_WIRE_TRANSACTION: {
      model_str: "indigo.SwiftWireTransaction",
      operation: "write",
      uuid: "*",
    },
    SWIFT_WIRE_TEMPLATE: {
      model_str: "indigo.SwiftWireTemplate",
      operation: "write",
      uuid: "*",
    },
    SWIFT_WIRE_VIA_TEMPLATE: {
      model_str: "indigo.SwiftWireViaTemplate",
      operation: "write",
      uuid: "*",
    },
    DOMESTIC_WIRE_IMPORT: {
      model_str: "indigo.DomesticWireImport",
      operation: "write",
      uuid: "*",
    },
    ACH_PAYMENT_VIA_TEMPLATE: {
      model_str: "indigo.ACHPaymentViaTemplate",
      operation: "write",
      uuid: "*",
    },
    ACH_PAYMENT_COLLECT_VIA_TEMPLATE: {
      model_str: "indigo.ACHPaymentCollectViaTemplate",
      operation: "write",
      uuid: "*",
    },
    BULK_PAYMENT_TEMPLATE: {
      model_str: "indigo.BulkPaymentTemplateGroup",
      operation: "write",
      uuid: "*",
    },
    APPROVE_ACH_TEMPLATES: {
      model_str: "indigo.ApproveACHTemplates",
      operation: "write",
      uuid: "*",
    },
    ACH_PAYMENT_REVERSE: {
      model_str: "indigo.ACHPaymentReverse",
      operation: "write",
      uuid: "*",
    },
    ACH_PAYMENT_COLLECT_REVERSE: {
      model_str: "indigo.ACHPaymentCollectReverse",
      operation: "write",
      uuid: "*",
    },
  },
} satisfies Business;
